/**
 * Historical Significance Item Component
 * Displays individual historical significance item with heading and description
 * Follows Single Responsibility Principle - only responsible for rendering a single item
 * Uses shared BulletListItem component
 */

import React from 'react';
import { BulletListItem } from '../shared/BulletListItem';
import { HistoricalSignificanceItemData } from './types';

export interface HistoricalSignificanceItemProps {
  /**
   * Historical significance item data
   */
  item: HistoricalSignificanceItemData;
}

/**
 * Historical Significance Item Component
 * Renders a single historical significance item using the shared bullet list item component
 * Matches Figma design: bullet point with bold heading followed by colon and description
 */
export const HistoricalSignificanceItem: React.FC<
  HistoricalSignificanceItemProps
> = ({ item }) => {
  return (
    <BulletListItem
      item={{
        id: item.id,
        heading: item.heading,
        description: item.description,
      }}
    />
  );
};
